import { t } from "i18next";
import { TextInput, FileUploadIcon, IconButton, TrashCanIcon, Button, ImageAddIcon } from "@datagame/ui";
import { useDropzone } from "react-dropzone";
import { useMutation } from "@apollo/client";

import { CREATE_VIDEO } from "../../../../../../../graphql/mutations/VideoMutatations";
import { Video } from "../../../../../../../gql/graphql";

import styles from "./VideoInput.module.scss";

export interface VideoInputProps {
  onUpload: (video?: Video) => void;
  video?: Video | null;
  onRemove: () => void;
}

export const VideoInput = ({ onUpload, video, onRemove }: VideoInputProps) => {
  const [uploadVideo] = useMutation(CREATE_VIDEO);
  const onFileUpload = (files: File[]) => {
    uploadVideo({
      variables: {
        input: {
          file: files[0]
        },
      },
      onCompleted: (data) => {
        onUpload(data.videoCreate as Video);
      },
    });
  };
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: onFileUpload,
    accept: {
      "video/*": [],
    },
    maxFiles: 1,
  });

  return (
    <div className={styles.videoSection}>
      <div className={styles.inputWrapper}>
        <TextInput size="small" icon={<FileUploadIcon />} readOnly value={video?.name} />
        {video && <IconButton onClick={onRemove} className={styles.deleteButton} icon={<TrashCanIcon />} />}
      </div>
      <div className={styles.uploadButtons}>
        <div {...getRootProps()} className={styles.button}>
          <input {...getInputProps()} />
          <Button kind="outline" className={styles.button} icon={<ImageAddIcon />} iconSide="left">
            {t("project:advancedSettings.form.upload")}
          </Button>
        </div>
      </div>
    </div>
  );
};
